// extracted by mini-css-extract-plugin
export default {"inputBox":"Input_inputBox__uvwVf","inputText":"Input_inputText__AX97Z","inputlabel":"Input_inputlabel__bGll6","error":"Input_error__KBg7D","icon":"Input_icon__jNv75"};